import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import loading from './en-US/loading';
import menu from './en-US/menu';
import pages from './en-US/pages';
import promoVideo from './en-US/promoVideo';
import siteAnalytics from './en-US/siteAnalytics';
import pwa from './en-US/pwa';
import questionModal from './en-US/questionModal';
import reviews from './en-US/reviews';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...promoVideo,
  ...siteAnalytics,
  ...loading,
  ...questionModal,
  ...reviews,
};
